'use strict';

const SessionStoage = {
    setItem(key, value) {
        if (window.sessionStorage) {
            sessionStorage.setItem(key, value);
        }
    },
    getItem(key) {
        if (window.sessionStorage) {
            return sessionStorage.getItem(key);
        }
        return '';
    },
    
};

export default SessionStoage;
